export default "__VITE_ASSET__Z3K94Z0W__"